import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type ItemValue = {
	id: string;
	name: string;
	displayName: string;
	fields: {
		hoverLinkLeftDescription: Field<string>;
		hoverLinkRightDescription: Field<string>;
		hoverLinkRight: LinkField;
		hoverLinkLeft: LinkField;
		link: LinkField;
		copyright: {
			value: string;
		};
		termsAndConditionsLink: LinkField;
		compliance: LinkField;
		logo: ImageField;
		image: ImageField;
		heading: { value: string };
		content: { value: string };
		viewalllink: LinkField;
		header: Field<string>;
	};
};
